module.exports = __webpack_public_path__ + "static/img/1959_03_20_NYTimes_NYURecital.02525f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1959_03_20_NYTimes_NYURecital.jpg
// module id = fX12
// module chunks = 0